export const styles = {
    actionMenuButton: {
        color: 'secondary.main !important',
        backgroundColor: 'primary.light',
    },
    titleWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    dialogTitle: {
        textAlign: 'center',
    },
    buttonsWrapper: {
        justifyContent: 'center',
    },
    growBox: {
        flexGrow: 1,
    },
};
